<template><div><h1 id="quellen" tabindex="-1"><a class="header-anchor" href="#quellen"><span>Quellen</span></a></h1>
<p>Quelle — Stammtabelle der Quellen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Quelle definiert die Herkunftsbezeichnung einer Fremdadresse oder von weitereren, frei definierbaren Quellen zur Person (z.B. manuell erfasst oder über eine Webschnittstelle).</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Quellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Quelle</dt>
<dd>Bezeichnung der Quelle</dd>
<dt>Fremd-DB</dt>
<dd>Nummer der <a class="link" href="ft.refdata.fremddb.html" title="Fremddatenbank">Fremddatenbank</a> , falls die Adressen in eine Fremddatenbank eingelesen worden sind.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Quelle.</dd>
<dt>Datum</dt>
<dd>Datum zur Quelle, frei editierbar. Es kann z.B. das Einlesedatum oder Versanddatum eingetragen werden.</dd>
<dt>Bemerkungen</dt>
<dd>Frei definierbare Informationen zur Quelle.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.fremddb.html" title="Fremddatenbank">Fremddatenbank</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.tblqzusatz.html" title="Quellenzusatz">Quellenzusatz</RouteLink></p>
</div></template>


